const metaEl = document.querySelector('meta[name=token]')
const token = metaEl ? metaEl.content : ''
export default {
  token,
  userInfo: {
    nick_name: '',
    account_name: '',
    account_type_str: '',
    email: '',
    phone: '',
    last_login_time: '',
    created_at: '',
    total_times: '',
    used_times: '',
    using_times: '',
    username: '',
    name: ''
  },
  // 所有权限表
  permissions: [],
  // 用户权限表
  userPermissions: [],
  routes: [],
  /**
   * 有访问权限的url数组
   */
  routeAuth: [],
  /**
   * 有操作权限的prop数组
   */
  operateAuth: [],
  xunjianRoutes: [],
  bzmjRoutes: [],
  gsgjRoutes: [],
  npsRoutes: [],
  task_type: {},
  business_type: {}
}
